var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
const StyledSvg = styled.svg `
  width: 30px;
  cursor: pointer;
  &:hover .hoverStyle {
    filter: invert(37%) sepia(91%) saturate(500%) hue-rotate(130deg)
      brightness(99%) contrast(94%);
  }
`;
export const CloseIcon = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30" },
        React.createElement("g", { id: "Group_1369", "data-name": "Group 1369", transform: "translate(9 9)", className: "hoverStyle" },
            React.createElement("line", { id: "_x39_1c3244b-a44b-4462-ad78-3b291975bc24_1_", y1: "12", x2: "12", fill: "none", stroke: "#282828", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
            React.createElement("line", { id: "dcc09f5c-b82c-4d96-b38b-0540c6362512_1_", x1: "12", y1: "12", fill: "none", stroke: "#282828", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" })),
        React.createElement("g", { id: "Ellipse_408", "data-name": "Ellipse 408", fill: "none", stroke: "#282828", strokeWidth: "1", className: "hoverStyle" },
            React.createElement("circle", { cx: "15", cy: "15", r: "15", stroke: "none" }),
            React.createElement("circle", { cx: "15", cy: "15", r: "14.5", fill: "none" }))));
};
//# sourceMappingURL=CloseIcon.js.map